// extracted by mini-css-extract-plugin
export default {"root":"DatabaseModal_root__7v+DZ"};